module.exports = __webpack_public_path__ + "64605fb077cf8f828c75890fb8215ce8.jpg";